module.exports = __webpack_public_path__ + "img/Cube.05d3af5e.png";